module.exports = __webpack_public_path__ + "static/individualImage-0a2462aabb39bd83828782ed002cd910.png";